import React, { useEffect, useState } from "react";
import Button from "../Common/Button";
import DarkModeToggle from "../Common/darkmode/darkModeToggle";

import { ReactComponent as WalletIcon } from "../../assets/icon/account_balance_wallet.svg";
import { ReactComponent as LoginIcon } from "../../assets/icon/btn_login.svg";
import { ReactComponent as TransactionIcon } from "../../assets/icon/clipboard-text.svg";
import { ReactComponent as LogoutIcon } from "../../assets/icon/material-symbols_logout.svg";
import { ReactComponent as SecureIcon } from "../../assets/icon/mdi_secure.svg";
import { ReactComponent as MembershipIcon } from "../../assets/icon/membership.svg";
import { ReactComponent as MenuIcon } from "../../assets/icon/menus.svg";
import { ReactComponent as SearchIcon } from "../../assets/icon/ri_search-line.svg";
import { ReactComponent as AddSaldoIcon } from "../../assets/icon/rotate_saldo.svg";
import { ReactComponent as Logolight } from "../../assets/logo_light.svg";
import { ReactComponent as BxsdiscountIcon } from "../../assets/icon/bxs_discount.svg";
import { ReactComponent as GiftCardIcon } from "../../assets/icon/ri_gift-line.svg";
import { ReactComponent as PointIcon } from "../../assets/icon/money-finance.svg";
import { ReactComponent as LogoDark } from "../../assets/logo_dark.svg";
import { ReactComponent as LogostaticDark } from "../../assets/yclogoooo.svg";


import { OverlayTrigger, Popover } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { isSideBar, searchAction } from "../../store/actions/todoActions";
import SearchBox from "../Common/SearchBox";
import useDarkMode from "../Common/darkmode/DarkModeObserver";
import LoadingProgress from "../Common/loadingProgress";
import { formatRupiah, useHandleClickLoading } from "../Common/utils";

function Header() {
  const isWebSetting = localStorage.getItem('isWebSetting');
  const parseWebSetting = JSON.parse(isWebSetting);
  const status = localStorage.getItem("isLogin");
  const isProfile = localStorage.getItem("isProfile");
  const handleClickLoading = useHandleClickLoading();
  const isDarkMode = useDarkMode();
  const [showOverlay, setShowOverlay] = useState(false);

  const handleCloseOverlay = () => {
    setShowOverlay(false);
  };
  
  const isSearch = useSelector((state) => state.todoReducer.isSearch);
  const profileData = JSON.parse(isProfile);
  const dispatch = useDispatch();

  return (
    <div className="flex flex-row  print:hidden bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]">
      <LoadingProgress />
      <div className="lg:container lg:mx-auto xl:max-w-screen-xl w-full flex  flex-row gap-3 justify-between items-center p-3 py-3">
        <div className="flex flex-row items-center gap-3 h-full justify-start">

          <button
            onClick={() => {
              handleClickLoading("/");
            }}
            className="flex items-center flex-row"
          >
            {!isDarkMode ? (
              <LogoDark className="sm:h-10 h-8 sm:max-w-[150px] max-w-[100px] hidden sm:flex" />
            ) : (
              <LogoDark className="sm:h-10 h-8 sm:max-w-[150px] max-w-[100px] hidden sm:flex" />
            )}
            <LogostaticDark className=" w-10 h-12 flex sm:hidden" />
          </button>
        </div>
        <div onClick={() => dispatch(searchAction(true))}
          className="flex flex-row gap-2 items-center cursor-pointer text-lightColor justify-between bg-lightColor shadow-inner p-1.5 h-full rounded-full flex-1 w-full ">
          <span className="opacity-60 text-sm pl-3 font-medium line-clamp-1 ">
            Cari Game, Voucher, Dll
          </span>
          <div className="bg-gradient-to-bl from-[#2AD1B5] to-[#218EA6] flex items-center justify-center h-full aspect-square rounded-full">
            <SearchIcon className="h-5 w-5" fill="#ffffff" />
          </div>
        </div>
        {!status ? (
          <div className="flex flex-row gap-2  justify-end">
            <Button
              type="transparent"
              color={isDarkMode ? "#ffffff" : "#ffffff"}
              iconLeft={<MenuIcon className={`w-5 h-6`} />}
              className=" text-darkColor sm:hidden flex"
              onClick={() => {
                dispatch(isSideBar(true));
              }}
            />
            <Button
              initialValue="Login"
              type="fill"
              color={"#ffffff"}
              iconLeft={<LoginIcon className={`w-5  `} />}
              className="hidden sm:inline-flex  bg-[#22BDE2] text-darkColor rounded-full px-4 h-[40px]"
              onClick={() => {
                handleClickLoading("/login");
                localStorage.setItem("isChoosePage", "Masuk");
              }}
            />
            <Button
              initialValue="Daftar"
              type="fill"
              color={isDarkMode ? "#ffffff" : "#ffffff"}
              iconLeft={<LoginIcon className={`w-5  `} />}
              className=" h-[40px] hidden sm:inline-flex rounded-full text-darkColor"
              onClick={() => {
                handleClickLoading("/login");
                localStorage.setItem("isChoosePage", "Daftar");
              }}
            />
          </div>
        ) : (
          <div className="flex flex-row gap-2  justify-end">
            {/* <div className="flex flex-row gap-2 items-center justify-center">
              <div className="inline-flex">
                <DarkModeToggle />
              </div>
            </div> */}
            <div className="flex flex-row gap-2 items-center ">
              <div className="hidden sm:flex  flex-col flex-1 text-darkColor">
                <span className=" text-base font-semibold line-clamp-1 text-right">
                  {profileData?.nama}
                </span>
                <span className="opacity-60 text-xs font-light line-clamp-1 ">
                  +{profileData?.ponsel}
                </span>
              </div>
              <OverlayTrigger
                // trigger={[ "focus"]}
                trigger="click"
                placement="bottom-end"
                show={showOverlay}
                onHide={handleCloseOverlay}
                overlay={
                  <Popover className="p-1 w-[1000px] bg-cardLight dark:bg-cardDark text-lightColor dark:text-darkColor">
                    <div className="p-2 flex flex-col ">
                      <div className="flex flex-row gap-2 items-center mb-1">
                        <div className="flex flex-col flex-1">
                          <span className="opacity-60 text-xs font-light line-clamp-1 ">
                            Saldo Anda
                          </span>
                          <span className=" text-xl font-semibold line-clamp-1">
                            {formatRupiah(profileData?.saldo)}
                          </span>
                          <span className=" text-md line-clamp-1">
                            {profileData?.poin || 0} Point
                          </span>
                        </div>
                        <div className="flex ">
                          <button
                            onClick={() => {
                              setShowOverlay(!showOverlay)
                              handleClickLoading('/topup')
                            }}
                          >
                            <AddSaldoIcon
                              fill={isDarkMode ? "#ffffff" : "#000000"}
                            />
                          </button>
                        </div>
                      </div>
                      <button
                        className="flex flex-row justify-start items-center gap-2 hover:bg-[#f3f3f30e] flex-1 p-2 rounded-md"
                        onClick={() => {
                          setShowOverlay(!showOverlay)
                          handleClickLoading('/history-order')
                        }}>
                        <TransactionIcon className=" h-6 w-6" fill={isDarkMode ? "#ffffff" : "#000000"} />
                        <span className=" text-base line-clamp-1 ">Riwayat Transaksi</span>
                      </button>
                      <button
                        className="flex flex-row justify-start items-center gap-2 hover:bg-[#f3f3f30e] flex-1 p-2 rounded-md"
                        onClick={() => {
                          setShowOverlay(!showOverlay)
                          handleClickLoading('/membership')
                        }}>
                        <MembershipIcon className=" h-6 w-6" fill={isDarkMode ? "#ffffff" : "#000000"} />
                        <span className=" text-base line-clamp-1 ">Membership</span>
                      </button>
                      <button
                        className="flex flex-row justify-start items-center gap-2 hover:bg-[#f3f3f30e] flex-1 p-2 rounded-md"
                        onClick={() => {
                          setShowOverlay(!showOverlay)
                          handleClickLoading('/cek-invoice')
                        }}>
                        <TransactionIcon className=" h-6 w-6" fill={isDarkMode ? "#ffffff" : "#000000"} />
                        <span className=" text-base line-clamp-1 ">Cek Pesanan</span>
                      </button>
                      <button
                        className="flex flex-row justify-start items-center gap-2 hover:bg-[#f3f3f30e] flex-1 p-2 rounded-md"
                        onClick={() => {
                          setShowOverlay(!showOverlay)
                          handleClickLoading('/claim-voucher')
                        }}>
                        <BxsdiscountIcon className=" h-6 w-6" fill={isDarkMode ? "#ffffff" : "#000000"} />
                        <span className=" text-base line-clamp-1 ">Reedem Voucher</span>
                      </button>
                      <button
                        className="flex flex-row justify-start items-center gap-2 hover:bg-[#f3f3f30e] flex-1 p-2 rounded-md"
                        onClick={() => {
                          setShowOverlay(!showOverlay)
                          handleClickLoading('/gift-card')
                        }}>
                        <GiftCardIcon className=" h-6 w-6" fill={isDarkMode ? "#ffffff" : "#000000"} />
                        <span className=" text-base line-clamp-1 ">Gift Card</span>
                      </button>
                      <button
                        className="flex flex-row justify-start items-center gap-2 hover:bg-[#f3f3f30e] flex-1 p-2 rounded-md"
                        onClick={() => {
                          setShowOverlay(!showOverlay)
                          handleClickLoading('/topup')
                        }}>
                        <WalletIcon className=" h-6 w-6" fill={isDarkMode ? "#ffffff" : "#000000"} />
                        <span className=" text-base line-clamp-1 ">Topup Saldo</span>
                      </button>
                      <button
                        className="flex flex-row justify-start items-center gap-2 hover:bg-[#f3f3f30e] flex-1 p-2 rounded-md"
                        onClick={() => {
                          setShowOverlay(!showOverlay)
                          handleClickLoading('/tukarpoin')
                        }}>
                        <PointIcon className=" h-6 w-6" fill={isDarkMode ? "#ffffff" : "#000000"} />
                        <span className=" text-base line-clamp-1 ">Tukar Point</span>
                      </button>
                      <button
                        className="flex flex-row justify-start items-center gap-2 hover:bg-[#f3f3f30e] flex-1 p-2 rounded-md"
                        onClick={() => {
                          setShowOverlay(!showOverlay)
                          handleClickLoading('/logsaldo')
                        }}>
                        <WalletIcon className=" h-6 w-6" fill={isDarkMode ? "#ffffff" : "#000000"} />
                        <span className=" text-base line-clamp-1 ">Log Saldo</span>
                      </button>
                      <button
                        className="flex flex-row justify-start items-center gap-2 hover:bg-[#f3f3f30e] flex-1 p-2 rounded-md"
                        onClick={() => {
                          setShowOverlay(!showOverlay)
                          handleClickLoading('/me')
                          localStorage.setItem('isChoosePage', ('EditProfile'));
                        }}>
                        <SecureIcon className=" h-6 w-6" fill={isDarkMode ? "#ffffff" : "#000000"} />
                        <span className=" text-base line-clamp-1 ">Setting Profile</span>
                      </button>
                      <button
                        className="flex flex-row justify-start items-center gap-2 hover:bg-[#f3f3f30e] flex-1 p-2 rounded-md"
                        onClick={() => {
                          setShowOverlay(!showOverlay)
                          localStorage.removeItem('isLogin');
                          localStorage.removeItem('isProfile');
                          handleClickLoading('/')
                        }}>
                        <LogoutIcon className=" h-6 w-6" fill={isDarkMode ? "#ffffff" : "#000000"} />
                        <span className=" text-base line-clamp-1 ">Log Out</span>
                      </button>
                    </div>
                    <div className="p-2 flex flex-row gap-2">
                      <button
                        onClick={() => {
                          setShowOverlay(!showOverlay)
                          handleClickLoading("/privacy")
                        }}
                        className="opacity-60 text-xs font-light line-clamp-1 "
                      >
                        Kebijakan Privasi
                      </button>
                      <button
                        onClick={() => {
                          setShowOverlay(!showOverlay)
                          handleClickLoading("/term-and-conditional")
                        }
                        }
                        className="opacity-60 text-xs font-light line-clamp-1 "
                      >
                        Persyaratan Layanan
                      </button>
                    </div>
                  </Popover>
                }
              >
                <button onClick={() => { setShowOverlay(!showOverlay) }}>
                  <img
                    src={profileData?.profil}
                    alt={profileData?.nama}
                    className=" object-contain flex h-11 w-11 bg-darkColor dark:bg-lightColor rounded-full"
                    effect="blur"
                  />
                </button>
              </OverlayTrigger>
            </div>
          </div>
        )}
      </div>
      <SearchBox
        active={isSearch}
        onClose={() => dispatch(searchAction(false))}
        className={"z-20"}
      />
    </div>
  );
}

export default Header;
